import { FvLinkButton } from '@fv/client-components'

import { Pinline } from '@/components/Pinline'

import { QuoteItemsForm } from './QuoteItemsForm'
import { getHasItems } from './quoteRequestUtils'
import {
  useQuoteFormActions,
  useQuoteFormLoads,
  useQuoteFormLocations,
} from './useQuoteFormState'

export const QuoteRequestHandlingUnits = () => {
  const { openQuoteItemsForm } = useQuoteFormActions()
  const loads = useQuoteFormLoads()
  const hasItems = getHasItems(loads)
  const locations = useQuoteFormLocations()

  return (
    <>
      <Pinline className="my-6" />
      <FvLinkButton
        icon="plus"
        onClick={openQuoteItemsForm}
        iconClass="fa-width-auto"
      >
        {hasItems ? 'Edit' : 'Add'} product dimensions / details for quote
        {!hasItems && ' (optional)'}
      </FvLinkButton>
      <Pinline className="my-6" />
      <QuoteItemsForm loads={loads} locations={locations} />
    </>
  )
}
